import {SaveIntegrationController} from '../controller/SaveIntegrationController';
import {BaseWebComponentElement} from '../../../framework/BaseWebComponentElement';
import {IntegrationActionContext} from "../../integrationsMarketplaceGridInstalled/types";

export class SaveIntegrationWebComponent extends BaseWebComponentElement {
  public controller!: SaveIntegrationController;
  actionContext: IntegrationActionContext;
  integrationId: string | null;
  type: number | null;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: SaveIntegrationController,
    });
  }

}
